// extracted by mini-css-extract-plugin
module.exports = {"Button":"CheckoutForm_Button__3kKXO","Checkout":"CheckoutForm_Checkout__BFoGR","Complete":"CheckoutForm_Complete__2HMyo","PaymentError":"CheckoutForm_PaymentError__1itEO"};